import React from 'react';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import {makeStyles} from "@material-ui/styles";

import {HeaderWithCloseButton} from "../tools/HeaderWithCloseButton/HeaderWithCloseButton";
import {DialogWithoutBackdropColor} from "../tools/DialogWithoutBackdropColor/DialogWithoutBackdropColor";

import {createDescription} from "../../utils/descriptionTemplate";


const useStyles = makeStyles(() => (
        {
            selectButton: {
                color: '#0A8100',
                border: '1px solid #0A8100',
                width: '150px',
                padding: '3px 3px'
            },
            returnButton: {
                width: '150px',
                padding: '3px 3px'
            },
            addButtonLabel: {
                fontSize: '0.55rem',
                fontWeight: 500,
                lineHeight: 1.57,
                letterSpacing: '0.00714em',
                display: 'inline'
            },
            fullNormativeArticleRow: {
                minHeight: '125px'
            },
            paper: {
                backgroundColor: '#F2F2F2',
                height: 'calc(100% - 64px)'
            }
        }
    )
)

export const FullNormativeArticleDialog = ({isOpenFullNormativeArticleWindow, closeFullNormativeArticleWindow, closeAll, handbookName, selectedNormativeArticle, selectedDocument, onCommitNormativeArticle}) => {
    const classes = useStyles()

    const onCommitButtonClick = () => {
        onCommitNormativeArticle({...selectedNormativeArticle, reference: createDescription(selectedNormativeArticle.number, selectedDocument.description)})
        closeAll()
    }
    const CommitButton = onCommitNormativeArticle ? <Button onClick={onCommitButtonClick} variant="outlined" size='small'
                                                   classes={{outlined: classes.selectButton}}>
        <Typography variant={'subtitle2'} classes={{subtitle2: classes.addButtonLabel}}>
            Добавить нарушение
        </Typography>
    </Button> : null

    return <DialogWithoutBackdropColor open={isOpenFullNormativeArticleWindow} onClose={closeFullNormativeArticleWindow}
                                       fullWidth maxWidth={'md'} scroll={'paper'} classes={{paper: classes.paper}}>
        <HeaderWithCloseButton onClose={closeAll}>
            <Grid item>
                <Button onClick={closeFullNormativeArticleWindow} size='small' variant="contained" color="primary"
                        classes={{outlined: classes.returnButton}}>
                    <Typography variant={'subtitle2'} classes={{subtitle2: classes.addButtonLabel}}>
                        Вернуться к поиску
                    </Typography>
                </Button>
            </Grid>
            <Grid item>
                {handbookName}
            </Grid>
        </HeaderWithCloseButton>
        <Divider/>
        <DialogContent>
            <Grid container direction={'column'}>
                <Grid item container className={classes.fullNormativeArticleRow} alignItems={'center'}>
                    <Grid item xs={2}>
                        <Typography variant={'h6'}>
                            Имя:
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        {selectedNormativeArticle?.short_text}
                    </Grid>
                </Grid>
                <Divider/>
                <Grid item container className={classes.fullNormativeArticleRow} alignItems={'center'}>
                    <Grid item xs={2}>
                        <Typography variant={'h6'}>
                            Полное имя:
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        {selectedNormativeArticle?.full_text}
                    </Grid>
                </Grid>
                <Divider/>
                <Grid item container className={classes.fullNormativeArticleRow} alignItems={'center'}>
                    <Grid item xs={2}>
                        <Typography variant={'h6'}>
                            Описание:
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        {createDescription(selectedNormativeArticle?.number, selectedDocument?.description)}
                    </Grid>
                </Grid>
                <Divider/>
            </Grid>
        </DialogContent>
        <DialogActions>
            {CommitButton}
        </DialogActions>
    </DialogWithoutBackdropColor>
}